import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import "react-modern-calendar-datepicker/lib/DatePicker.css"

import ReactHTMLTableToExcel from "react-html-table-to-excel"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const Shorttext = (text) => {
      if (text.length < 10) {
            return text
      } else {
            return "..." + text.substr(0, 20)
      }
}
class ChangeReportCreatTafzili extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfos1: [],
                  requestinfofilter: [],
                  requestinfo1filter: [],
                  rowsPerPage: 10,
                  page: 0,
                  rowsPerPage1: 10,
                  page1: 0,
                  RefundUser: null,
                  orderBy: "SarfaslTaffs_ID",
                  order: "desc",
                  orderBy1: "SarfaslTaffs_ID",
                  order1: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFinancialDocPaing()
                                    self.getFinancialDocPaing2()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getFinancialDocPaing() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "send_tafzili_send")
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/creatdoc`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getFinancialDocPaing2() {
            const { rowsPerPage1, page1 } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos1: arr.data, requestinfo1filter: arr.data, arrCount1: arr.cnt }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "send_sarfasl_send")
            fd.append("limit", rowsPerPage1)
            fd.append("offset", page1 * rowsPerPage1)

            xhttp.open("POST", `${constants.BASE_URL}/creatdoc`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getFinancialDocPaing()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getFinancialDocPaing()
            })
      }

      createSortHandler1 = (field) => {
            if (this.state.orderBy1 === field) {
                  if (this.state.order1 === "asc") {
                        this.setState({ order1: "desc" })
                  } else {
                        this.setState({ order1: "asc" })
                  }
            } else {
                  this.setState({ orderBy1: field, order1: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfo1filter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order1 === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order1 === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage1 = (event) => {
            this.setState({ rowsPerPage1: parseInt(event.target.value), page1: 0 }, () => {
                  this.getFinancialDocPaing2()
            })
      }

      handleChangePage1 = (event, number) => {
            this.setState({ page1: parseInt(number, 0) }, () => {
                  this.getFinancialDocPaing2()
            })
      }

      render() {
            const { classes } = this.props
            const {
                  snackMode,
                  snackstr,
                  showSnack,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  order1,
                  orderBy1,
                  requestinfo1filter,
                  rowsPerPage1,
                  page1,
                  arrCount1,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />

                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"SarfaslTaffs_ID"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "SarfaslTaffs_ID" ? order : false}
                                                                              >
                                                                                    {"SarfaslTaffs_ID"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "SarfaslTaffs_ID"}
                                                                                          direction={orderBy === "SarfaslTaffs_ID" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("SarfaslTaffs_ID")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"RowID"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"RowID"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "RowID"}
                                                                                          direction={orderBy === "RowID" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("RowID")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"Shobe"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Shobe"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "Shobe"}
                                                                                          direction={orderBy === "Shobe" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Shobe")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"CodeTaf_Group"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"CodeTaf_Group"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "CodeTaf_Group"}
                                                                                          direction={orderBy === "CodeTaf_Group" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeTaf_Group")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"CodeTaf"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"CodeTaf"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "CodeTaf"}
                                                                                          direction={orderBy === "CodeTaf" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeTaf")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"CodeTaf2_Group"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"CodeTaf2_Group"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "CodeTaf2_Group"}
                                                                                          direction={orderBy === "CodeTaf2_Group" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeTaf2_Group")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"CodeTaf2"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"CodeTaf2"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "CodeTaf2"}
                                                                                          direction={orderBy === "CodeTaf2" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeTaf2")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Sharh"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Sharh "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "Sharh"}
                                                                                          direction={orderBy === "Sharh" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Sharh")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Mahiat"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Mahiat"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "Mahiat"}
                                                                                          direction={orderBy === "Mahiat" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Mahiat")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Arz"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Arz"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "Arz"}
                                                                                          direction={orderBy === "Arz" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Arz")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Disable"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Disable"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "Disable"}
                                                                                          direction={orderBy === "Disable" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Disable")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"IsMeghdari"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"IsMeghdari"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "IsMeghdari"}
                                                                                          direction={orderBy === "IsMeghdari" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("IsMeghdari")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["SarfaslTaffs_ID"]}
                                                                                          value={row}
                                                                                          onClick={() => {}}
                                                                                    >
                                                                                          <TableCell key={"SarfaslTaffs_ID"} align={"center"}>
                                                                                                {row["SarfaslTaffs_ID"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"RowID"} align={"center"}>
                                                                                                {row["RowID"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Shobe"} align={"center"}>
                                                                                                {row["Shobe"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeTaf_Group"} align={"center"}>
                                                                                                {row["CodeTaf_Group"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeTaf"} align={"center"}>
                                                                                                {row["CodeTaf"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeTaf2_Group"} align={"center"}>
                                                                                                {row["CodeTaf2_Group"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeTaf2"} align={"center"}>
                                                                                                {row["CodeTaf2"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Sharh"} align={"center"}>
                                                                                                {row["Sharh"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"Mahiat"} align={"center"}>
                                                                                                {row["Mahiat"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"Arz"} align={"center"}>
                                                                                                {row["Arz"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Disable"} align={"center"}>
                                                                                                {row["Disable"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"IsMeghdari"} align={"center"}>
                                                                                                {row["IsMeghdari"]}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>

                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />

                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"Sarfasl_ID"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy1 === "Sarfasl_ID" ? order : false}
                                                                              >
                                                                                    {"Sarfasl_ID"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Sarfasl_ID"}
                                                                                          direction={orderBy1 === "Sarfasl_ID" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Sarfasl_ID")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"Shobe"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Shobe"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Shobe"}
                                                                                          direction={orderBy1 === "Shobe" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Shobe")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"Grp"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Grp"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Grp"}
                                                                                          direction={orderBy1 === "Grp" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Grp")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"CodeKol"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"CodeKol"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "CodeKol"}
                                                                                          direction={orderBy1 === "CodeKol" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeKol")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"CodeMoin"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"CodeMoin"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "CodeMoin"}
                                                                                          direction={orderBy1 === "CodeMoin" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeMoin")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"CodeTaf"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"CodeTaf"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "CodeTaf"}
                                                                                          direction={orderBy1 === "CodeTaf" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeTaf")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"CodeTaf2"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"CodeTaf2"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "CodeTaf2"}
                                                                                          direction={orderBy1 === "CodeTaf2" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("CodeTaf2")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Sharh"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Sharh "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Sharh"}
                                                                                          direction={orderBy1 === "Sharh" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Sharh")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Mahiat"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Mahiat"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Mahiat"}
                                                                                          direction={orderBy1 === "Mahiat" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Mahiat")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Arz"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Arz"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Arz"}
                                                                                          direction={orderBy1 === "Arz" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Arz")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"Disable"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"Disable"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "Disable"}
                                                                                          direction={orderBy1 === "Disable" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("Disable")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"IsMeghdari"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"IsMeghdari"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy1 === "IsMeghdari"}
                                                                                          direction={orderBy1 === "IsMeghdari" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("IsMeghdari")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfo1filter.slice(0, rowsPerPage1).map((row) => {
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["Sarfasl_ID"]}
                                                                                          value={row}
                                                                                          onClick={() => {}}
                                                                                    >
                                                                                          <TableCell key={"Sarfasl_ID"} align={"center"}>
                                                                                                {row["Sarfasl_ID"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Shobe"} align={"center"}>
                                                                                                {row["Shobe"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Grp"} align={"center"}>
                                                                                                {row["Grp"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeKol"} align={"center"}>
                                                                                                {row["CodeKol"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeMoin"} align={"center"}>
                                                                                                {row["CodeMoin"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeTaf"} align={"center"}>
                                                                                                {row["CodeTaf"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"CodeTaf2"} align={"center"}>
                                                                                                {row["CodeTaf2"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Sharh"} align={"center"}>
                                                                                                {row["Sharh"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"Mahiat"} align={"center"}>
                                                                                                {row["Mahiat"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"Arz"} align={"center"}>
                                                                                                {row["Arz"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"Disable"} align={"center"}>
                                                                                                {row["Disable"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"IsMeghdari"} align={"center"}>
                                                                                                {row["IsMeghdari"]}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>

                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount1}
                                                            rowsPerPage={rowsPerPage1}
                                                            page={page1}
                                                            onChangePage={this.handleChangePage1}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage1}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeReportCreatTafzili)
